import React, { useMemo } from 'react';
import { PharmacyStatus } from '../../../store/models';
import { Instance } from 'mobx-state-tree';
import { Tooltip2 } from '@blueprintjs/popover2';
import { PHARMACY_STATUS_AC, PHARMACY_STATUS_TC } from '../../../common/constants/pharmacyStatusConstants';

export interface PharmacyStatusCellProps {
  pharmacyStatus: Instance<typeof PharmacyStatus>;
}

// This function is used to show the pharmacyStatus for datagrid (Devextreme)
export const PharmacyStatusCell = ({ pharmacyStatus }: PharmacyStatusCellProps) => {
  const circleToDisplay = useMemo(() => {
    let circleColor = 'red';
    switch (pharmacyStatus.code) {
      case PHARMACY_STATUS_AC:
        circleColor = 'green';
        break;
      case PHARMACY_STATUS_TC:
        circleColor = 'orange';
        break;
      default:
        break;
    }
    return (
      <Tooltip2 content={<div style={{ maxWidth: '150px' }}>{pharmacyStatus.code + ' - ' + pharmacyStatus.name}</div>}>
        <svg height="15" width="15">
          <circle r="5" cx="8" cy="8" fill={circleColor} />
        </svg>
      </Tooltip2>
    );
  }, [pharmacyStatus]);

  return <>{circleToDisplay}</>;
};
